/**
 * Updates active navigation items based on the current URL path.
 *
 * @param {string} [selector='[data-slug]'] - CSS selector for nav items
 * @param {string} [activeClass='active'] - Class to apply when active
 */
export function navActiveState(
   selector = '[data-slug]',
   activeClass = 'active',
) {
   const currentPath = window.location.pathname;
   const navItems = document.querySelectorAll(selector);

   navItems.forEach((item) => {
      const slug = item.dataset.slug?.trim();
      const isActive = Boolean(slug && currentPath.includes(slug));

      item.classList.toggle(activeClass, isActive);

      if (isActive) {
         item.setAttribute('aria-current', 'page');
      } else {
         item.removeAttribute('aria-current');
      }
   });
}
